import React from 'react'

const PasswordField = ({enteredCorrectly=true,password_bullets}) => {
  let bullets = "";
  for (let i = 0; i < password_bullets; i++) {
      bullets += "*";
  } 
  return (
    <>
        <label style={{marginTop:"20px"}}>Enter Password<span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>   {enteredCorrectly && <span style={{color:"#198754"}}>(Was Correctly Entered)</span>}</label>
        <input type="password" disabled value={bullets}/>
    </>
  )
}

export default PasswordField